import { render } from "./WhatsAppMetaDetailPage.vue?vue&type=template&id=5797c2ab&ts=true"
import script from "./WhatsAppMetaDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppMetaDetailPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/WhatsAppMetaDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5797c2ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5797c2ab', __exports__)) {
    api.reload('5797c2ab', __exports__)
  }
  
  module.hot.accept("./WhatsAppMetaDetailPage.vue?vue&type=template&id=5797c2ab&ts=true", () => {
    api.rerender('5797c2ab', render)
  })

}


export default __exports__